const loadMoreOffers = () => {
    try {
        let loadButton = document.querySelector('#loadMoreMain');
        let offers = document.querySelectorAll('.grid-line-main');
        let step = 5;
		
		if( offers.length <= step ) {
			loadButton.style.display = 'none';
		}    

        if (loadButton) {
            
            window.addEventListener('resize', function(event) {
                if( window.innerWidth > 768) {
                    for( let i = 0; i < offers.length; i++ ) {
                        if( i < step ) {
                            offers[i].style.display = 'grid';
                        } else {
                            offers[i].style.display = 'none';
                        }
                    }
    
                    loadButton.addEventListener('click', function() {
                        step = step + 5;
                        for( let i = 0; i < offers.length; i++ ) {
                            if( i < step ) {
                                offers[i].style.display = 'grid';
                            } else {
                                offers[i].style.display = 'none';
                            }
                        }
                        if( offers.length <= step ) {
                            loadButton.style.display = 'none';
                        }        
                    });
                    
                } else if (window.innerWidth < 768) {
                    for( let i = 0; i < offers.length; i++ ) {
                        if( i < step ) {
                            offers[i].style.display = 'block';
                        } else {
                            offers[i].style.display = 'none';
                        }
                    }
            
                    loadButton.addEventListener('click', function() {
                        step = step + 5;
                        for( let i = 0; i < offers.length; i++ ) {
                            if( i < step ) {
                                offers[i].style.display = 'block';
                            } else {
                                offers[i].style.display = 'none';
                            }
                        }
                        if( offers.length <= step ) {
                            loadButton.style.display = 'none';
                        }        
                    });
                }
            }, true);
        
        
            if( window.innerWidth > 768) { 
                for( let i = 0; i < offers.length; i++ ) {
                    if( i < step ) {
                        offers[i].style.display = 'grid';
                    } else {
                        offers[i].style.display = 'none';
                    }
                }
        
                loadButton.addEventListener('click', function() {
                    step = step + 5;
                    for( let i = 0; i < offers.length; i++ ) {
                        if( i < step ) {
                            offers[i].style.display = 'grid';
                        } else {
                            offers[i].style.display = 'none';
                        }
                    }
                    if( offers.length <= step ) {
                        loadButton.style.display = 'none';
                    }        
                });
            } else if (window.innerWidth < 768){
             
                for( let i = 0; i < offers.length; i++ ) {
                    if( i < step ) {
                        offers[i].style.display = 'block';
                    } else {
                        offers[i].style.display = 'none';
                    }
                }
        
                loadButton.addEventListener('click', function() {
                    step = step + 5;
                    for( let i = 0; i < offers.length; i++ ) {
                        if( i < step ) {
                            offers[i].style.display = 'block';
                        } else {
                            offers[i].style.display = 'none';
                        }
                    }
                    if( offers.length <= step ) {
                        loadButton.style.display = 'none';
                    }        
                });
            }
        }
        
    } catch(e) {}
}

export default loadMoreOffers;